module.exports = __webpack_public_path__ + "img/trinity_core.1b42e406.png";